
import { createAsionInstance } from "../../interceptors/axios/axios-instance";
import { API_TIMEOUT, BaseApi as localBase } from "../../interceptors/base-axios/base-axios";


const glueBaseDownlaod = createAsionInstance({
    baseURL: "https://dss-customer-glue-service-emedbkgp-dev.apps.dev.aks.forgeapp.honeywell.com",
    timeout: API_TIMEOUT,
});


export const BaseApi = { ...localBase, glueBaseDownlaod }